import { render, staticRenderFns } from "./balance-report.vue?vue&type=template&id=37c7b403"
import script from "./balance-report.vue?vue&type=script&lang=js"
export * from "./balance-report.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports